import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GeneralService} from "../../../../services/generalService";
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {DICTIONARY} from "../../../../dictionary";

@Component({
  selector: 'collaboration-asset-info',
  templateUrl: './collaboration-asset-info.component.html'
})
export class CollaborationAssetInfoComponent {
	constructor(private rs:RouteService, public gs:GeneralService, private ns:NotificationService) {}

	@Input('asset') assetObj;
	@Output() closeCb = new EventEmitter<any>();

	dic = DICTIONARY;

	actionInProcess;
	previewAttachment;

	linkScopeTooltips: Record<string, string> = {
		anonymous: 'Anyone with the link can access (no login required)',
		organization: 'All users in your company can access (must sign in)',
		users: 'Only users with existing access (must sign in)',
		external: 'At least one or more external user has an access to this file'
	};

	viewMessage = () => {
		this.actionInProcess = true;
		this.rs.getAssetMessage(this.assetObj._id).then((response) => {
			this.assetObj.content = response?.content;
			this.actionInProcess = false;
		}, (err) => {
			this.actionInProcess = false;
		});
	}

	viewFile = () => {
		this.actionInProcess = true;
		this.rs.getAssetFile(this.assetObj._id).then((response) => {
			this.previewAttachment = response;
			this.actionInProcess = false;
		}, (err) => {
			this.actionInProcess = false;
		});
	}

	releaseAssetAction = () => {
		this.gs.showPopup({
			title: 'Release Asset',
			subTitle: 'Are you sure you want to release this asset?',
			body: ['Asset will be restored to its original folder'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Release',
			doneCb: () => {
				this.rs.doAssetAction(this.assetObj._id, {action: 'release'}).then((response) => {
					this.assetObj.is_quarantine = false;
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, (err) => {
				});
			}
		});
	}

	quarantineAssetAction = () => {
		this.gs.showPopup({
			title: 'Quarantine Asset',
			subTitle: 'Are you sure you want to quarantine this asset?',
			body: ['Asset will be quarantined in a dedicated SharePoint site'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Quarantine',
			doneCb: () => {
				this.rs.doAssetAction(this.assetObj._id, {action: 'quarantine'}).then((response) => {
					this.assetObj.is_quarantine = true;
					this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
				}, (err) => {
				});
			}
		});
	}
}
